// Browsers without :focus-visible (Safari < 15.4) throw, so the tooltip never
// opens on focus there
export const isFocusVisible = (element: Element): boolean => {
  try {
    return element.matches(':focus-visible');
  } catch {
    return false;
  }
};
